/**
 * @file vehicleTableConfig.js
 * @description Configuración de columnas para la tabla de vehículos
 */

// 1. DEFINICIÓN DEL UNIVERSO DE COLUMNAS
export const ALL_COLUMNS_CONFIG = [
    { id: 'vin', label: 'VIN', sortable: true },
    { id: 'marca', label: 'Marca', sortable: true },
    { id: 'familia', label: 'Familia', sortable: true },
    { id: 'anoModelo', label: 'Año', sortable: true },
    { id: 'catalogo', label: 'Catálogo', sortable: true },
    { id: 'colorExt', label: 'Color Ext.', sortable: true },
    { id: 'colorInt', label: 'Color Int.', sortable: true },
    { id: 'patio', label: 'U. Negocio', sortable: true },
    { id: 'ubicacion', label: 'Ubicación', sortable: true },
    { id: 'status', label: 'Status', sortable: true },
    { id: 'estado', label: 'Estado', sortable: true },
    { id: 'ultimaLectura', label: 'Última Lectura', sortable: true },
    { id: 'enSitio', label: 'En Sitio', sortable: true },
    { id: 'VTE_DOCTO', label: 'N° Factura', sortable: true },
    { id: 'vendedor', label: 'Vendedor', sortable: true },
    { id: 'fecha', label: 'F. Recibido', sortable: true }
];

// 2. COLUMNAS POR DEFECTO
export const DEFAULT_COLUMN_IDS = [
    'vin', 'marca', 'familia', 'anoModelo', 'catalogo', 'colorExt',
    'colorInt', 'VTE_DOCTO', 'vendedor', 'patio', 'ubicacion',
    'status', 'estado', 'ultimaLectura', 'enSitio', 'fecha'
];
